export default __webpack_public_path__ + "static/media/Caramel-Cake.6b5eb5f0.jpg";